import PropTypes from "prop-types";

export const formikPropType = PropTypes.shape({
  values: PropTypes.shape({
    bannerName: PropTypes.string,
    position: PropTypes.string,
    startDate: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    endDate: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    targetDevices: PropTypes.arrayOf(PropTypes.string),
    contentRedirect: PropTypes.string,
  }).isRequired,
  touched: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func,
  submitForm: PropTypes.func,
  setFieldValue: PropTypes.func,
  setFieldTouched: PropTypes.func,
}).isRequired;

export const existingRecordPropType = PropTypes.shape({
  createdOn: PropTypes.string,
  createdByName: PropTypes.string,
  updatedOn: PropTypes.string,
  updatedByName: PropTypes.string,
  status: PropTypes.number,
});
